export const HOME = 'HOME';

export const STORY = 'STORY';

export const TEAM = 'TEAM';

export const TOP = 'TOP';

export const NOTTOP = 'NOTTOP';